"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var AddToWaitlistModalController = /** @class */ (function () {
    function AddToWaitlistModalController($uibModalInstance, UsersModel, WaitListModel, FlashService, sessionTypes, courseTypes) {
        this.$uibModalInstance = $uibModalInstance;
        this.UsersModel = UsersModel;
        this.WaitListModel = WaitListModel;
        this.FlashService = FlashService;
        this.sessionTypes = sessionTypes;
        this.courseTypes = courseTypes;
        this.student = null;
        this.students = [];
        this.searchingStudents = false;
        this.waitListableType = "";
        this.waitListableId = null;
        this.durationHours = 0;
        this.durationMinutes = 0;
        this.desiredDate = "";
        this.desiredTime = "";
        this.availableTypes = [];
        this.submitting = false;
        this.searchStudents = this.searchStudents.bind(this);
        this.updateDesiredDate = this.updateDesiredDate.bind(this);
        this.updateDesiredTime = this.updateDesiredTime.bind(this);
    }
    AddToWaitlistModalController.prototype.updateDesiredDate = function (event) {
        this.desiredDate = event.selected[0] || "";
    };
    AddToWaitlistModalController.prototype.updateDesiredTime = function (event) {
        this.desiredTime = event.selected[0] || "";
    };
    AddToWaitlistModalController.prototype.searchStudents = function (search) {
        var _this = this;
        if (this.searchingStudents) {
            return;
        }
        if (!search || search.length < 3) {
            return;
        }
        this.searchingStudents = true;
        this.UsersModel.searchStudentsByName({ name: search })
            .then(function (response) {
            _this.students = response.students;
            _this.searchingStudents = false;
        })
            .catch(function () {
            _this.searchingStudents = false;
        });
    };
    AddToWaitlistModalController.prototype.onTypeChange = function () {
        this.waitListableId = null;
        if (this.waitListableType === "session_type") {
            this.availableTypes = this.sessionTypes;
        }
        else if (this.waitListableType === "course_type") {
            this.availableTypes = this.courseTypes;
        }
        else {
            this.availableTypes = [];
        }
    };
    AddToWaitlistModalController.prototype.getTotalMinutes = function () {
        return this.durationHours * 60 + this.durationMinutes;
    };
    AddToWaitlistModalController.prototype.submit = function () {
        var _this = this;
        var totalMinutes = this.getTotalMinutes();
        if (!this.student ||
            !this.waitListableType ||
            !this.waitListableId ||
            !totalMinutes ||
            !this.desiredDate ||
            !this.desiredTime) {
            return;
        }
        this.submitting = true;
        this.FlashService.clearFlash();
        var datePart = (0, time_1.formatDateTime)(this.desiredDate, "YYYY-MM-DD");
        var timePart = (0, time_1.formatDateTime)(this.desiredTime, "HH:mm:ss");
        var request = {
            wait_listable_type: this.waitListableType,
            wait_listable_id: Number(this.waitListableId),
            minutes: totalMinutes,
            user_id: this.student.id,
            desired_at: datePart + " " + timePart,
        };
        this.WaitListModel.create(request)
            .then(function (response) {
            _this.$uibModalInstance.close(response.waitList);
        })
            .catch(function (error) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                type: "warning",
                message: error.data.detail,
            });
        });
    };
    AddToWaitlistModalController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss("cancel");
    };
    return AddToWaitlistModalController;
}());
AddToWaitlistModalController.$inject = [
    "$uibModalInstance",
    "UsersModel",
    "WaitListModel",
    "FlashService",
    "sessionTypes",
    "courseTypes",
];
exports.default = AddToWaitlistModalController;
